import loggerService from './logger.service';

import { getEnv } from '@/constants';

export function getSessionOnlineAttendeeCounts(eventId: string): Promise<{ [k: string]: number }> {
  const lambdaurl = getEnv('VUE_APP_API_ONLINE_USERS_STATUS');
  return fetch(`${lambdaurl}?event_id=${eventId}`)
    .then(response => response.json())
    .catch(error => {
      loggerService.warn('Error in getting socket counts', error);
      return {};
    });
}
